module.exports = __webpack_public_path__ + "media/images/icon-link-a6c8d758cf58dbd29a9f05b7cba8205b.svg";